import { InternalId } from '@edgebox/data-definition-kit';
import { ClientPoolEntity } from '@edgebox/sync-core-rest-client';
import { faSpinner } from '@fortawesome/pro-duotone-svg-icons/faSpinner';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { ISyncCoreApiComponentState, SyncCoreApiComponent } from '../services/SyncCoreApiComponent';

interface IProps {
  id: InternalId;
  light?: boolean;
  inline?: boolean;
}

interface IState extends ISyncCoreApiComponentState {
  pool?: ClientPoolEntity;
}

export class PoolName extends SyncCoreApiComponent<IProps, IState> {
  async load() {
    const { id } = this.props;

    const pool = await this.api.syndication.pools.item(id);

    return {
      pool,
    };
  }

  render() {
    const { light, inline } = this.props;

    const { pool } = this.state;
    if (pool) {
      if (inline) {
        return pool.name;
      }

      return <span className="text-truncate d-inline-block mw-100">{pool.name}</span>;
    }

    return <FontAwesomeIcon icon={faSpinner} spin className={`text-${light ? 'light' : 'dark'}`} style={{ fontSize: '1.4em' }} />;
  }
}
